module.exports = __webpack_public_path__ + "img/dummy-book.d1c9296.webp";